import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import * as GameHistoryDetailsActions from './game-history-details.actions';
import {
  GameHistoryService,
  UserService,
} from '@fantaz/shared/data-access/api';
import { map, switchMap } from 'rxjs/operators';
import { catchError, concatMap, of } from 'rxjs';

@Injectable()
export class GameHistoryDetailsEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GameHistoryDetailsActions.loadGameHistoryDetail),
        concatMap(({ params }) => {
          return this.gameHistoryApiService.getGameHistoryDetails(params).pipe(
            map((details) => {
              return GameHistoryDetailsActions.loadGameHistoryDetailsSuccess({
                gameHistoryDetails: details,
              });
            }),
            catchError((error) => {
              return of(
                GameHistoryDetailsActions.loadGameHistoryDetailsFailure({
                  error,
                }),
              );
            }),
          );
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private gameHistoryApiService: GameHistoryService,
    private readonly actions$: Actions,
    private readonly userService: UserService,
  ) {}
}
